import { createSlice } from "@reduxjs/toolkit";
import { initialStateProps } from '../interfaces/services';

const initialState: initialStateProps = {
    services: {
        fetching: "unknown",
        data: []
    },
}

const servicesSlice = createSlice({
    name: "services",
    initialState,
    reducers: {
        servicesRequest: (state) => {
            state.services.fetching = "loading";
        },
        servicesSuccess: (state, action) => {
            state.services.fetching = "success";
            state.services.data = action.payload;
        },
        servicesFailure: (state) => {
            state.services.fetching = "failure";
        },
        cleanServicesReducer: (state) => {
            state.services.fetching = initialState.services.fetching;
        },
    },
});

export const {
    servicesRequest,
    servicesSuccess,
    servicesFailure,
    cleanServicesReducer,
} =
    servicesSlice.actions;

export default servicesSlice.reducer;
